import { render, staticRenderFns } from "./DatosOperacion.vue?vue&type=template&id=f8ca05c2&scoped=true&"
import script from "./DatosOperacion.vue?vue&type=script&lang=js&"
export * from "./DatosOperacion.vue?vue&type=script&lang=js&"
import style0 from "./DatosOperacion.vue?vue&type=style&index=0&id=f8ca05c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ca05c2",
  null
  
)

export default component.exports